import { Controller } from '@hotwired/stimulus';
import { agencyFees, parkingFees } from '../../shared/helpers/agencyFeesHelper';

export default class extends Controller {
  static targets = ['mandatePrice', 'warning', 'noWarning', 'sendMandate', 'premiumMandate', 'finePropertyMandate', 'agencyFees', 'exclusivity', 'buyerFees', 'mandateFeesPercentage', 'simpleReason']
  static values = {
    feesRegion: String,
    parkingKind: Boolean,
    agencyFees: Number,
    liquidSale: Boolean,
    leadAgent: Boolean,
    estimationHigh: Number
  }

  connect() {
    this.displayWarning();

    if (!this.leadAgentValue) this.buyerFeesTarget.onclick = (e) => { e.preventDefault(); }
    this.premiumMandateTarget.checked ? this.disallowPremium() : this.checkPremium();
    this.finePropertyMandateTarget.checked ? this.disallowFineProperty() : this.checkFineProperty();
    this.computeFees();
    this.updateSimpleReasonVisibility();
  }

  displayWarning() {
    const mandatePrice = parseInt(this.mandatePriceTarget.value.replace(/\s+/g, ''))
    const delta = (mandatePrice - this.estimationHighValue) / this.estimationHighValue * 100

    if(!this.leadAgentValue && !this.parkingKindValue) {
      if (isNaN(delta)) {
        this.noWarningTarget.classList.add('hidden')
        this.warningTarget.classList.add('hidden')
        this.sendMandateTarget.disabled = true
      } else if (delta < 5 || this.liquidSaleValue) {
        this.noWarningTarget.classList.remove('hidden')
        this.warningTarget.classList.add('hidden')
        this.sendMandateTarget.disabled = false
      } else if (delta >= 5) {
        this.warningTarget.classList.remove('hidden')
        this.noWarningTarget.classList.add('hidden')
        this.sendMandateTarget.disabled = true
      }
    }
  }

  computeFees() {
    this.checkPremium();
    this.checkFineProperty();

    const mandatePrice = parseInt(this.mandatePriceTarget.value.replace(/\s+/g, '')) || 0;
    const noExclusivity = this.exclusivityTargets.filter(target => target.value == 'false')[0];

    let newFees = (this.parkingKindValue ? parkingFees(noExclusivity.checked) : agencyFees(
      this.feesRegionValue,
      mandatePrice,
      noExclusivity.checked
    )).toLocaleString('fr-FR');

    this.agencyFeesTarget.value = newFees;
    this.agencyFeesTarget.nextElementSibling.value = parseInt(newFees.replace(/\s+/g, ''));

    this.computeFeesPercentage()
  }

  computeFeesPercentage() {
    const mandatePrice = parseInt(this.mandatePriceTarget.value.replace(/\s+/g, '')) || 0;
    const fees = parseInt(this.agencyFeesTarget.value.replace(/\s+/g, ''))
    const percentage = (fees/mandatePrice)*100

    if (typeof percentage === 'number' && isFinite(percentage)) {
      this.mandateFeesPercentageTarget.innerText = `${Math.round(percentage*100)/100}%`
    } else {
      this.mandateFeesPercentageTarget.innerText = ''
    }
  }

  checkPremium() {
    const mandatePrice = parseInt(this.mandatePriceTarget.value.replace(/\s+/g, ''));

    const threshold = this.feesRegionValue == 'Paris'
                      ? process.env.PREMIUM_START_VALUE_PARIS
                      : process.env.PREMIUM_START_VALUE_REGIONS;

    if (mandatePrice > threshold) {
      this.premiumMandateTarget.checked = true
      this.disallowPremium();
    } else {
      this.premiumMandateTarget.checked = false
      this.allowPremium();
    }
  }

  checkFineProperty() {
    const mandatePrice = parseInt(this.mandatePriceTarget.value.replace(/\s+/g, ''));

    const threshold = this.feesRegionValue == 'Paris'
                      ? process.env.FINE_PROPERTIES_START_VALUE_PARIS
                      : process.env.FINE_PROPERTIES_START_VALUE_REGIONS;

    if (mandatePrice > threshold) {
      this.finePropertyMandateTarget.checked = true
      this.disallowFineProperty();
    } else {
      this.finePropertyMandateTarget.checked = false
      this.allowFineProperty();
    }
  }

  disallowPremium() {
    if (!this.leadAgentValue) {
      this.premiumMandateTarget.classList.add('not-allowed-cursor');
      this.premiumMandateTarget.onclick = (e) => { e.preventDefault(); }
    }
  }

  allowPremium() {
    if (!this.leadAgentValue) {
      this.premiumMandateTarget.classList.remove('not-allowed-cursor');
      this.premiumMandateTarget.onclick = null;
    }
  }

  disallowFineProperty() {
    if (!this.leadAgentValue) {
      this.finePropertyMandateTarget.classList.add('not-allowed-cursor');
      this.finePropertyMandateTarget.onclick = (e) => { e.preventDefault(); }
    }
  }

  allowFineProperty() {
    if (!this.leadAgentValue) {
      this.finePropertyMandateTarget.classList.remove('not-allowed-cursor');
      this.finePropertyMandateTarget.onclick = null;
    }
  }

  toggleSimpleReason() {
    this.updateSimpleReasonVisibility();
  }

  updateSimpleReasonVisibility() {
    const isSimple = this.exclusivityTargets.find(t => t.value === 'false')?.checked;
    this.simpleReasonTarget.classList.toggle('hidden', !isSimple);
  }
}
